module.exports = __webpack_public_path__ + "static/apple-319ea3825bf4546b7e234aff2848a02c.svg";